import { render, staticRenderFns } from "./GasStation.vue?vue&type=template&id=58bf32d4"
import script from "./GasStation.vue?vue&type=script&lang=js"
export * from "./GasStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports